module.exports = __webpack_public_path__ + "img/NP.69c57d63.svg";